import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GeneralSetting } from '../../model/GeneralSetting';
import { generalSettingStorage } from '../../utils/StorageUtils';

interface GeneralSettingsState {
    generalSettings: GeneralSetting;
}

const getDefaultSettings = (): GeneralSetting => ({
    LastDailyFreeHeartGetDate: '0',
    ServiceWorkerLastUpdate: '0',
    LastAdHeartGetDate: '0',
    AdHeartCount: 0,
    UncoverWordCount: 0,
    ChallengeCount: 0,
    RangePopUpCount: 0,
    ShowRangePopUp: true,
    ShowHardWordBanner: true,
    HardWordBannerCloseCount: 0
});

export const defaultGeneralSettings = getDefaultSettings();

const isDefaultSettings = (settings: GeneralSetting): boolean => {
    const defaultSettings = getDefaultSettings();
    return Object.keys(defaultSettings).every(key =>
        settings[key as keyof GeneralSetting] === defaultSettings[key as keyof GeneralSetting]
    );
};

const initialState: GeneralSettingsState = {
    generalSettings: getDefaultSettings()
};

const generalSettingsSlice = createSlice({
    name: 'generalSettings',
    initialState,
    reducers: {
        getSettings: (state) => {
            if (isDefaultSettings(state.generalSettings)) {
                const storedSettings = generalSettingStorage.get();
                if (storedSettings) {
                    state.generalSettings = storedSettings;
                }
            }
        },
        setGeneralSettings: (state, action: PayloadAction<GeneralSetting>) => {
            generalSettingStorage.set(action.payload);
            state.generalSettings = action.payload;
        },
        updateGeneralSettings: (state, action: PayloadAction<Partial<GeneralSetting>>) => {
            const updatedSettings = { ...state.generalSettings, ...action.payload };
            generalSettingStorage.set(updatedSettings);
            state.generalSettings = updatedSettings;
        },
        logout: (state) => {
            generalSettingStorage.set(null);
            state.generalSettings = getDefaultSettings();
        }
    }
});

export const generalSettingsActions = generalSettingsSlice.actions;
export default generalSettingsSlice.reducer; 